// extracted by mini-css-extract-plugin
export var footer = "_py-5";
export var fulfillmentInput = "_py-0";
export var shipDateInput = "_py-1";
export var shipmentModal = "_py-2";
export var shipmentModalContent = "_py-3";
export var tableContainer = "_py-4";